import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout, { PublicHero } from '../../components/layout/PublicLayout';
import { FileText, ArrowRight } from 'lucide-react';

// Reusable product catalogue (add future products here — no redesign needed)
const PRODUCTS = [
  {
    id: 'lios',
    name: 'LIOS',
    tagline: 'Intelligent document management',
    desc: 'A focused workspace for reading, organising and working with legal documents. Currently in a testing stage.',
    status: 'In Testing',
    path: '/products/lios',
    active: true,
  },
];

const Products = () => {
  const navigate = useNavigate();
  return (
    <PublicLayout title="Products" description="Explore the VSKR Legal product ecosystem, including LIOS document intelligence.">
      <PublicHero eyebrow="Products" title="A focused, growing product ecosystem"
        subtitle="Each VSKR Legal product does one job well. Today, our featured product is LIOS." />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-20">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {PRODUCTS.map((p) => (
            <button key={p.id} onClick={() => p.active && navigate(p.path)} data-testid={`product-card-${p.id}`}
              className="glass-card p-7 rounded-2xl text-left transition-transform hover:scale-[1.02] group">
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center text-white" style={{ background: 'linear-gradient(135deg,#1E3A5F,#2D8CFF)' }}>
                  <FileText className="w-6 h-6" />
                </div>
                <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-[#D4AF37]/15 text-[#D4AF37]">{p.status}</span>
              </div>
              <h3 className="text-xl font-bold">{p.name}</h3>
              <p className="text-sm text-[#2D8CFF] mt-0.5">{p.tagline}</p>
              <p className="text-sm opacity-70 mt-3 leading-relaxed">{p.desc}</p>
              <span className="inline-flex items-center gap-1.5 mt-5 text-sm font-semibold text-[#2D8CFF] group-hover:gap-2.5 transition-all">Learn more <ArrowRight className="w-4 h-4" /></span>
            </button>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
};

export default Products;
